import { render } from "./p-form.vue?vue&type=template&id=c2b14848"
import script from "./p-form.vue?vue&type=script&lang=js"
export * from "./p-form.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__